import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.store'
import VuexPersistence from 'vuex-persist'
import transactions from './transactions.store'
import withdrawal from './withdrawal.store'
import report from './report.store'
import common from './common.store'
import terminal from './terminal.store'
import externalApi from './externalApi.store'
import paymentLink from './paymentLink.store'
import kyc from './kyc.store'
import bridge from './bridge.store'
import bulkPayout from './bulkPayout.store'
import appTour from './appTour.store'
import error from './error.store'
import notification from './notification.store'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  modules: {
    auth,
    transactions,
    report,
    withdrawal,
    common,
    terminal,
    externalApi,
    paymentLink,
    kyc,
    bridge,
    bulkPayout,
    appTour,
    error,
    notification
  },
  plugins: [vuexLocal.plugin]
})
// store.registerModule('auth', auth)

export default store
